
import Vue from 'vue';
import VueRouter from 'vue-router';
import UnicodeTool from '../tools/UnicodeTool.vue';
import UrlTool from '../tools/UrlTool.vue';
import Base64Tool from '../tools/Base64Tool.vue';
import HexTool from '../tools/HexTool.vue';

Vue.use(VueRouter);

const routes = [
    { path: '/', component: UnicodeTool },
    { path: '/tools/unicode', component: UnicodeTool },
    { path: '/tools/url', component: UrlTool },
    { path: '/tools/base64', component: Base64Tool },
    { path: '/tools/hex', component: HexTool }
    // 添加更多工具路径
   // { path: '*', redirect: '/' } // default
];

const router = new VueRouter({
    mode: 'hash', 
    routes
});

export default router;
